<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import SelectBox from "../../../../compositions/SelectBox.vue";
import Chart from "../../../../compositions/Chart.vue";
import SummaryMedicineComponent from '../../../Common/SummaryMedicineComponent.vue';
import config from "../../../../config.js";
import { errorAlert } from "../../../../plugins/alert";
import { getFieldValue } from "../../../../plugins/utility";
import qs from 'qs';
import axios from '../../../../plugins/axios.ts';
import { deepCopy } from "../../../../plugins/utility";
import HelpAction from '../../../../compositions/HelpAction.vue';
import axios_org from 'axios';

let cancelSummary = null;
let cancelSummaryHistory = null;

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    identityId: {
      typ:Number,
      default:() => {
        return 0;
      }
    },
    searchParams: {
      typ:Object,
      default:() => {
        return {};
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    }
})

const { isVisible,identityId,searchParams } = toRefs(props);
const listRef = ref();
const searchParamsData = reactive(props.searchParams);
const medicineSummaryFields = reactive([
  {field_name: '薬局名', field_key: 'pharmacy_name', width: '15%', align: 'text-left',sorted:true},
  {field_name: '採用品', field_key: 'product_detail_name', width: '20%', align: 'text-left',sorted:true},
  {field_name: '使用期限', field_key: 'expire_date', width: '10%', align: 'text-center',sorted:true},
  {field_name: '最新<br>薬価', field_key: 'medicine_unit_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '最新<br>購入額', field_key: 'current_unit_price', width: '5%', align: 'text-center',sorted:true},
  {field_name: '在庫数', field_key: 'real_stock_number', width: '5%', align: 'text-center',sorted:true},
  {field_name: '薬価在庫金額', field_key: 'real_stock_price_org', width: '5%', align: 'text-center',sorted:true},
  {field_name: '在庫金額(税込)', field_key: 'real_stock_price', width: '5%', align: 'text-center',sorted:true},
]);
const summaryData = reactive([]);
const summaryChartPriceData = reactive([]);
const summaryChartCountData = reactive([]);
const summaryHistoryType = ref(0);
const isChartLoading = ref(false);
const summaryHistoryOptions = reactive([
  {id:0,name:'年単位'},
  {id:1,name:'月単位'},
]);
const onSummaryHistoryTypeChange = (value,label) => {
  summaryHistoryType.value = value;
  getSummaryHistory();
}
const getSummary = async () => {
  let params = deepCopy(searchParamsData);
  const paramsSerializer = (params) => qs.stringify(params,{ arrayFormat: 'repeat'});
  let response = await axios.get(props.apis.summary_stock_summary,{params:params,paramsSerializer,cancelToken:  new axios_org.CancelToken((c) => {
        cancelSummary = c;
      })});
  summaryData.splice(0);
  summaryData.push(response.data.summary);
}
const getSummaryHistory = async () => {
  let params = deepCopy(searchParamsData);
  params['history_type'] = summaryHistoryType.value;
  const paramsSerializer = (params) => qs.stringify(params,{ arrayFormat: 'repeat'});
  isChartLoading.value = true;
  try {
    let response = await axios.get(props.apis.summary_stock_real_estate_summary_list,{params:params,paramsSerializer,cancelToken:  new axios_org.CancelToken((c) => {
        cancelSummaryHistory = c;
      })});
    let chartPriceRecord = {};
    let chartCountRecord = {};
    chartPriceRecord.labels = [];
    chartCountRecord.labels = [];
    for (let i=0;i<response.data.list.length;i++) {
      chartPriceRecord.labels.push(response.data.list[i].summary_key);
      chartCountRecord.labels.push(response.data.list[i].summary_key);
    }
    chartPriceRecord.datasets = [];
    chartCountRecord.datasets = [];
    let stock_price = [];
    let stock_count = [];
    for (let i=0;i<response.data.list.length;i++) {
      stock_price.push(response.data.list[i].stock_price);
      stock_count.push(response.data.list[i].stock_count);
    }
    chartPriceRecord.datasets.push({
        type:'line',
        label:'不動在庫料金',
        backgroundColor:'#2dc181',
        data:stock_price,
    });
    chartCountRecord.datasets.push({
        type:'line',
        label:'不動在庫数量',
        backgroundColor:'#ffc181',
        data:stock_count,
    });
    summaryChartPriceData.splice(0);
    summaryChartCountData.splice(0);
    summaryChartPriceData.push(chartPriceRecord);
    summaryChartCountData.push(chartCountRecord);

  } finally {
    isChartLoading.value = false;
  }
}

const refreshView = (force=false) => {
  if (isVisible.value == false) {
    return;
  }
  if (typeof listRef.value !== 'undefined') {
    listRef.value.resetItem();
    getSummary();
    getSummaryHistory();
  }
}
watch(isVisible,(newValue, oldValue) => {
  if (newValue) {
    refreshView();
  }
})
watch(identityId,(newValue, oldValue) => {
  refreshView();
})
watch(searchParams,(newValue, oldValue) => {
  if (cancelSummary) {
    cancelSummary();
    cancelSummary = null;
  }
  if (cancelSummaryHistory) {
    cancelSummaryHistory();
    cancelSummaryHistory = null;
  }
  //条件に薬局が追加されたら列を追加する
  let newPharmacyIds = oldValue['pharmacy_ids'];
  if (newPharmacyIds.length == 1 && newPharmacyIds[0] == 0) {
    newPharmacyIds = [];
  }
  if (newPharmacyIds.length > 0) {
    let exists = false;
    for (let i=0;i<medicineSummaryFields.length;i++) {
      if (medicineSummaryFields[i].field_key == 'pharmacy_name') {
        exists = true;
        break;
      }
    }
    if (exists == false) {
      medicineSummaryFields.unshift({field_name: '薬局名', field_key: 'pharmacy_name', width: '10%', align: 'text-left',sorted:true});
    }
  } else {
    for (let i=0;i<medicineSummaryFields.length;i++) {
      if (medicineSummaryFields[i].field_key == 'pharmacy_name') {
        medicineSummaryFields.splice(i,1);
        break;
      }
    }
  }
  refreshView();
},{deep:true})
onMounted(() => {
  refreshView();
});
</script>

<style scoped>
.summary-header {
  min-height:54px;
}
.summary-chart {
  min-height:342px;
}
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="absolute top-2 left-2" style="z-index:39;">
    <help-action
      help-key="dashboard_real_estate_help"
    ></help-action>
  </div>
  <div class="pl-8 w-full border flex items-center justify-between px-4 summary-header" v-for="(summaryRecord,index) in summaryData" :key="index">
    <div class="text-center">
      <div><span class="border-b text-sm">不動品金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.pharmacy_medicine_old_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="border-b text-sm">不動品目数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.pharmacy_medicine_old_count.toLocaleString() }}</div>
    </div>
  </div>
  <div class="w-full mt-1">
    <div class="font-bold">【不動品一覧】</div>
    <custom-list
      ref="listRef"
      :api-url="apis.summary_stock_real_estate_list"
      :table-fields="medicineSummaryFields"
      :option-fields="searchParamsData"
      :is-downloadable="true"
      font-size="0.8em"
      height="40vh"
    >
    <template v-slot:item="slotProps">
      <summary-medicine-component
        :apis="apis"
        :item="slotProps.item"
        :fields="medicineSummaryFields"
      ></summary-medicine-component>
    </template>
    </custom-list>
  </div>
  <div class="w-full mt-1 flex flex-row summary-chart">
    <div v-show="isChartLoading" class="loading-mask">
      <div class="loading-content">
        <span style="color: white"><img src="../../../../../public/images/loading.gif"></span>
      </div>
    </div>
    <div class="w-2/4 pr-4" v-for="(summaryChartHistoryCountRecord,index) in summaryChartCountData" :key="index">
      <div class="font-bold">【時系列(不動在庫数量)】</div>
      <div class="w-1/5">
        <select-box
          :value="summaryHistoryType"
          :options="summaryHistoryOptions"
          :on-change="onSummaryHistoryTypeChange"
        ></select-box>
      </div>
      <div>
        <chart
          chart-type="bar"
          height="280px"
          :chart-data="summaryChartHistoryCountRecord"
        ></chart>
      </div>
    </div>
    <div class="w-2/4 pr-4" v-for="(summaryChartHistoryPriceRecord,index) in summaryChartPriceData" :key="index">
      <div class="font-bold mb-10">【時系列(不動在庫料金)】</div>
      <div>
        <chart
          chart-type="bar"
          height="280px"
          :chart-data="summaryChartHistoryPriceRecord"
        ></chart>
      </div>
    </div>
  </div>
</div>
</template>
